import type { LiveCommentDocument } from "popopo-msg"

/**
 * コメント種別の日本語ラベルを取得
 */
export const getCommentKindLabel = (kind: LiveCommentDocument["kind"]): string => {
  switch (kind) {
    case "text": return "テキスト"
    case "emotion": return "エモーション"
    case "image": return "画像"
    case "joinToSpace": return "入室"
    case "silentJoinToSpace": return "静かに入室"
    case "power": return "パワー"
    case "reaction": return "リアクション"
    case "aggregated-reactions": return "集約リアクション"
    case "followOwner": return "フォロー"
    case "superCallOn": return "スーパーコールON"
    default: return kind satisfies never
  }
}

/**
 * unknown な値を安全に文字列に変換
 */
const safeDisplayValue = (value: unknown): string => {
  if (typeof value === "string") return value
  if (value === null || value === undefined) return ""
  return JSON.stringify(value)
}

/**
 * コメントの表示用テキストを取得
 */
export const getCommentDisplayValue = (comment: LiveCommentDocument): string => {
  switch (comment.kind) {
    case "text":
    case "emotion":
      return safeDisplayValue(comment.value)
    case "image":
      return safeDisplayValue(comment.value) || "(画像)"
    case "joinToSpace":
      return "(入室)"
    case "silentJoinToSpace":
      return "(静かに入室)"
    case "power":
      return safeDisplayValue(comment.value.power.name)
    case "reaction":
      return JSON.stringify(comment.value.counts)
    case "aggregated-reactions":
      return JSON.stringify(comment.value)
    case "followOwner":
      return "(フォロー)"
    case "superCallOn":
      return "(スーパーコールON)"
    default: return JSON.stringify((comment as { value?: unknown }).value ?? "")
  }
}

/**
 * お題投稿画像の URL を取得
 * SelectionParticipantDocument / SelectionParticipantNominateDocument の両方で利用可能
 */
export const getParticipantImageUrl = (participant: { media?: { value?: string }; image?: string }): string | null => {
  if (participant.media?.value) return participant.media.value
  if (participant.image) return participant.image
  return null
}

/**
 * Firestore ドキュメントパスからスペースキーを抽出
 */
export const extractSpaceKeyFromLiveCommentDocumentPath = (path: string[]): string => {
  const spacesIndex = path.indexOf("spaces")
  if (0 <= spacesIndex && spacesIndex + 1 < path.length) {
    return path[spacesIndex + 1]
  }
  return ""
}

/**
 * Firestore ドキュメントパスからライブIDを抽出
 */
export const extractLiveIdFromLiveCommentDocumentPath = (path: string[]): string => {
  const livesIndex = path.indexOf("lives")
  if (0 <= livesIndex && livesIndex + 1 < path.length) {
    return path[livesIndex + 1]
  }
  return ""
}
